import { create } from 'zustand';

export interface ISelectRow {
  selectRow: string;
  setselectRow: (rowId: string) => void;
}

export const useSelectingRow = create<ISelectRow>(set => ({
  selectRow: '',
  setselectRow: selectRow => set({ selectRow }),
}));
